module.exports = __webpack_public_path__ + "static/media/DM-Negative-Clip-1.fefaabf1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Negative-Clip-1.mp3
// module id = 131
// module chunks = 0